<script>
  import CarouselWrapper from './CarouselWrapper.svelte';
  import CarouselTabs from './CarouselTabs.svelte';

  export let collections;
  export let sectionSettings;
  export let productHandle;

  let settingsData = JSON.parse(sectionSettings);
  let collectionData = JSON.parse(collections);
  let viewAllBackground = collectionData[0].viewAllBackground.replaceAll('"','').trim();
  let viewAllButtonColour = collectionData[0].viewAllButton.replaceAll('"','').trim();
</script>

<CarouselTabs {collectionData} />

<CarouselWrapper
  collectionHandle={collectionData[0].handle}
  spacing={settingsData.spacing}
  {viewAllButtonColour}
  {viewAllBackground}
  {productHandle}
  maxProducts={settingsData.maxProducts}
/>
